module.exports = __webpack_public_path__ + "img/Dataservicesselect.eb02b385.svg";